import React, { useEffect, useRef, useState } from "react";
import "./banner.styles.css";
import CallIcon from "../../svg/call";
import ArrowRight from "../../svg/arrowRight";
import UnifiedNavigation from "../unified-navigation/UnifiedNavigation";
import RightSmGreenVectors from "../../vectors/banner/right-tiny";
import BottomLeftVectors from "../../vectors/banner/botton-left";
import XVectorComponent from "../XVector/xVector.component";
import { motion, useInView, useAnimation } from "framer-motion";
import homeImages from "../../data/homeImages";
import { BANNER_VIDEO_URL } from "../../utils/mediaUrl";

const fadeUp = {
  hidden: { opacity: 0, y: 48 },
  visible: { opacity: 1, y: 0 },
};

const Banner = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();
  const [videoSrc, setVideoSrc] = useState(null);

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView, mainControls]);

  useEffect(() => {
    const loadVideo = () => setVideoSrc(BANNER_VIDEO_URL);
    if (typeof window.requestIdleCallback === "function") {
      const id = window.requestIdleCallback(loadVideo, { timeout: 2500 });
      return () => window.cancelIdleCallback(id);
    }
    const timer = window.setTimeout(loadVideo, 400);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="banner">
      <div className="banner-wrap">
        <UnifiedNavigation variant="overlay" currentPage="home" />
        <video
          className="banner-image"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          poster={homeImages.banner}
        >
          {videoSrc && <source src={videoSrc} type="video/mp4" />}
        </video>
        <motion.div
          ref={ref}
          className="banner-content container"
          initial="hidden"
          animate={mainControls}
          variants={{
            hidden: {},
            visible: {
              transition: { staggerChildren: 0.12 },
            },
          }}
        >
          <span className="mission">Mission</span>
          <motion.h1
            className="empower"
            variants={fadeUp}
            transition={{ duration: 1.2 }}
          >
            Empowering African tech talent
          </motion.h1>
          <motion.p
            className="content-text"
            variants={fadeUp}
            transition={{ duration: 1.2, delay: 0.15 }}
          >
            At Werkix, we are fueled by a passion to reshape the tech industry
            by seamlessly connecting talented individuals in Africa with
            abundant global market opportunities.
          </motion.p>
          <motion.a
            href="tel:+265888007888"
            className="phone"
            variants={fadeUp}
            transition={{ duration: 1, delay: 0.5 }}
            aria-label="Call Werkix at +265 888 007 888"
          >
            <CallIcon />
            <span>+265 888 007 888</span>
            <ArrowRight />
          </motion.a>
        </motion.div>
        <span className="bottom-right-vectors" aria-hidden="true">
          <RightSmGreenVectors />
        </span>
        <XVectorComponent />
        <span className="bottom-left-vectors" aria-hidden="true">
          <BottomLeftVectors />
        </span>
      </div>
    </div>
  );
};

export default Banner;
